import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import CareerBanner from './career-banner';
import CareerDescription from './career-description';
import CareerList from './career-lists';
import CareerParallax from './career-parallax'; 

function CareerPage () {
    return(
      <Fragment> 
      <Header />  
      <CareerBanner /> 
      <CareerDescription />
      <CareerList />    
      <CareerParallax />  
      <Footer /> 
      </Fragment> 
    );
}
export default CareerPage;